import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { NavigationButtonProps } from './Types'
import Styles from './NavigationButton.module.scss'
import cx from 'classnames'
import { useIsScheduledPostsV3 } from 'hooks/isScheduledPostsV3'

export const NavigationButton = ({ icon, onPress, side, isDisabled, chatOpen }: NavigationButtonProps) => {
  const isScheduledPostsV3 = useIsScheduledPostsV3()
  return (
    <div
      className={cx(Styles.navigation, {
        [Styles.right]: side === 'right',
        [Styles.left]: side === 'left',
        [Styles.chatOpen]: chatOpen,
        [Styles.isFixed]: !isScheduledPostsV3,
      })}
      data-testid={`navigation-button-${side}`}
    >
      <IconButton rounded icon={icon} variant="secondary" onPress={onPress} size="xl" isDisabled={isDisabled} />
    </div>
  )
}
